module.exports = __webpack_public_path__ + "img/sign-icon.ddd00228.svg";